import axios from "axios";
import "./sidebar.css";
import React, { useEffect, useState } from 'react';
import { CgMenuBoxed } from "react-icons/cg";
import { Button, Col, Row } from "react-bootstrap";
import { MdFavorite } from "react-icons/md";
import { MdDeleteOutline,MdModeEditOutline, MdClose, MdDone ,  } from 'react-icons/md';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Cookies from 'js-cookie';
import { dotWave } from 'ldrs'
import { ring2 } from 'ldrs';
import { IoClose } from 'react-icons/io5';
import { RiChatDeleteLine } from "react-icons/ri";
import {decryptData } from "../../../Auth/cryptage";
import logoGc from "../../../imgs/LogoGcDarkBg.png";






const Sidebar = ({ isOpen, onClose, onQuestionClick, setUpdateSidebarQuestions,newChat,handleSave }) => {
    const [modeles, setModeles] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [isModelesDropdownOpen, setIsModelesDropdownOpen] = useState(false);
    const [isQuestionsDropdownOpen, setIsQuestionsDropdownOpen] = useState(false);
    const [editQuestionId, setEditQuestionId] = useState(null);
    const [editedTitle, setEditedTitle] = useState('');
    const [loading, setLoading] = useState({ who: '', status: false,question:null });
    const MySwal = withReactContent(Swal);
    dotWave.register();
    ring2.register();

    useEffect(() => {
        getModeles();
    }, []);

    useEffect(() => {
        if (setUpdateSidebarQuestions) {
            setUpdateSidebarQuestions(async () => await getModeles());
        }
    }, []);


    const getModeles = async () => {
        setLoading({ who: 'data', status: true, question: null });
    
        const token = decryptData(Cookies.get('access_token'));
        
        try {
            const [modelesResponse, questionsResponse] = await Promise.all([
                axios.get('http://127.0.0.1:8000/api/user/modeles', {
                    headers: { 'X-Custom-Token': token }
                }),
                axios.get('http://127.0.0.1:8000/api/user/user-question', {
                    headers: { 'X-Custom-Token': token }
                })
            ]);
    
            setModeles(modelesResponse.data.modeles);
            setQuestions(questionsResponse.data.questions);
    
        } catch (error) {
            console.error("Error fetching data: ", error);
            
            Swal.fire({
                title: 'Error!',
                text: 'There was an issue fetching the data. Please try again later.',
                icon: 'error'
            });
        } finally {
            setLoading({ who: 'data', status: false, question: null });
        }
    };

    const toggleDropdown = (dropdown) => {
        if (dropdown === 'modeles') {
            setIsModelesDropdownOpen(!isModelesDropdownOpen);
            setIsQuestionsDropdownOpen(false);
        } else if (dropdown === 'questions') {
            setIsQuestionsDropdownOpen(!isQuestionsDropdownOpen);
            setIsModelesDropdownOpen(false);
        }
    };

    const handleEditClick = (questionId, currentTitle) => {
        setEditQuestionId(questionId);
        setEditedTitle(currentTitle);
    };

    const handleTitleChange = (e) => {
        setEditedTitle(e.target.value);
    };

    const handleSaveClick = async (questionId) => {
        setLoading(true);
    
        try {
            const token = decryptData(Cookies.get('access_token'));
            // console.log()(editedTitle,questionId);
            await axios.put(`http://127.0.0.1:8000/api/user/update-title/${questionId}`, 
                { title: editedTitle },
                {
                    headers: {
                        'X-Custom-Token': token
                    }
                }
            );

            setQuestions(prevQuestions => 
                prevQuestions.map(q => 
                    q.id === questionId ? { ...q, title: editedTitle } : q
                )
            );

            setEditQuestionId(null);
            Swal.fire({
                title: 'Success!',
                text: 'Question updated successfully.',
                icon: 'success'
            });
    
        } catch (error) {
            console.error("Error updating question: ", error.response || error.message || error);
            Swal.fire({
                title: 'Error!',
                text: error.response?.data?.message || error.message || 'An unknown error occurred.',
                icon: 'error'
            });
        }
        finally {
            setLoading(false);
        }
    };

    const handleDelete = async (questionId) => {
        const { isConfirmed } = await MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to undo this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });
    
        if (isConfirmed) {
            setLoading({ who: 'delete', status: true, question: questionId });
    
            try {
                const token = decryptData(Cookies.get('access_token'));
                await axios.delete(`http://127.0.0.1:8000/api/user/destroy-question/${questionId}`, {
                    headers: {
                        'X-Custom-Token': token
                    }
                });
    
                setQuestions(prevQuestions => prevQuestions.filter(q => q.id !== questionId));
    
                await MySwal.fire({
                    title: "Deleted!",
                    text: "The question has been deleted.",
                    icon: "success"
                });
    
            } catch (error) {
                console.error("Error deleting question: ", error);
    
                await MySwal.fire({
                    title: "Error!",
                    text: "An error occurred while deleting the question. Please try again later.",
                    icon: "error"
                });
            } finally {
                setLoading({ who: 'delete', status: false, question: null });
            }
        }
    };

    const handleCancelClick = () => {
        setEditQuestionId(null);
        setEditedTitle('');
    };

    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <button className="close-btn" onClick={onClose}>
                <IoClose className='nav_icon' />
            </button>
            <img src={logoGc} className='Logo-image-sidebar' alt="logo-gecimmo" />
            <button className="newChat-btn" onClick={newChat}>
                <RiChatDeleteLine className='nav_icon' />
            </button>
            <div className="dropdown">
                <button className="dropdown-btn" onClick={() => toggleDropdown('modeles')}>
                    <CgMenuBoxed className='nav_icon nav_icon_Mod' /> 
                    {loading.who === 'data' && loading.status ? (
                        <l-dot-wave size="47" speed="1" color="white"></l-dot-wave>
                    ) : (
                        "Question modeles"
                    )}
                </button>
                <div className={`dropdown-contentM ${isModelesDropdownOpen ? 'show' : ''}`}>
                    {modeles.map((modele, index) => (
                        <Row className="contentMItem d-flex justify-content-between p-0"> 
                            <Col xs={10} className="" key={index} onClick={() => onQuestionClick(modele.content)}>
                                {modele.content}
                            </Col>
                            <Col xs={2}>
                                <Button 
                                    className="btnQEdit me-1 p-0 bg-transparent text-danger fs-4" 
                                    onClick={() => handleSave(modele.content)}
                                >
                                    <MdFavorite />
                                </Button>
                            </Col>
                        </Row>
                    ))}
                </div>
            </div>
            <div className="dropdown">
                <button className="dropdown-btn" onClick={() => toggleDropdown('questions')}>
                    <MdFavorite className='nav_icon nav_icon_fav' /> 
                    {loading.who === 'data' && loading.status ? (
                        <l-dot-wave size="47" speed="1" color="white"></l-dot-wave>
                    ) : (
                        "Questions favorie"
                    )}
                </button>
                <div className={`dropdown-contentQ ${isQuestionsDropdownOpen ? 'show' : ''}`}>
                    {questions.map((question, index) => (
                        <div key={index} className="contentQItem d-flex justify-content-between align-items-center h-50">
                            {editQuestionId === question.id ? (
                                <input 
                                    type="text" 
                                    value={editedTitle} 
                                    onChange={handleTitleChange} 
                                    className="form-control w-75 me-2"
                                />
                            ) : (
                                <span className="titleSpan w-75" onClick={() => onQuestionClick(question.content)}>
                                    {question.title}
                                </span>
                            )}
                            <div className="d-flex justify-content-around w-50 h-50 p-0">
                                {editQuestionId === question.id ? (
                                    <>
                                        <Button 
                                            className="btnQEdit me-1 p-0 bg-transparent text-success fs-4" 
                                            onClick={() => handleSaveClick(question.id)}
                                        >
                                            <MdDone />
                                        </Button>
                                        <Button 
                                            className="btnQDelete me-1 p-0 bg-transparent text-danger fs-4" 
                                            onClick={handleCancelClick}
                                        >
                                            <MdClose />
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button 
                                            className="btnQEdit me-1 p-0 bg-transparent text-success fs-4" 
                                            onClick={() => handleEditClick(question.id, question.title)}
                                        >
                                            <MdModeEditOutline />
                                        </Button>
                                        <Button 
                                            className="btnQDelete me-1 p-0 bg-transparent text-danger fs-4"
                                            onClick={() => handleDelete(question.id)}
                                        >
                                            {loading.who==='delete' && loading.status && loading.question=== question.id ? (
                                                <l-ring-2
                                                    size="25"
                                                    stroke="3"
                                                    stroke-length="0.25"
                                                    bg-opacity="0.1"
                                                    speed="0.8"
                                                    color="red"
                                                ></l-ring-2>
                                            ) : (
                                                <MdDeleteOutline />
                                            )}
                                        </Button>
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
